import * as ApiUrl from "api/routes";
import { instance, noAuthInstance } from "hooks/useRequest/helper"
import tokenService from "services/token.service";


export const createUser = async body => {
    return await instance.post(ApiUrl.USER_URL, { ...body })
        .then(res => res.data)
};

export const updateUser = async ({ id, data }) => {
    return await instance.put(ApiUrl.USER_URL + "/" + id, {
        ...data,
        headers: {
            authorization: `Token ${tokenService.getLocalAccessToken()}`
        }
    })
        .then(res => res.data)
};

export const login = async ({ data }) => {
    return await instance.post(ApiUrl.USER_URL + "/login", { ...data })
        .then(res => res.data)
};

export const signup = async ({ data }) => {
    return await instance.post(ApiUrl.USER_URL + "/signup", { ...data })
        .then(res => res.data)
};

export const verify = async ({ data }) => {
    const response = await instance.post(ApiUrl.USER_URL + "/verify", { ...data })
    return await response.data
};

export const resendVerifyCode = async ({ data }) => {
    return await instance.post(ApiUrl.USER_URL + "/resend-verify-code", { ...data })
        .then(res => res.data)
};

export const loginWithId = async ({ id }) => {
    return await noAuthInstance.post(ApiUrl.LOGIN_WITH_ID_URL + "/" + id, {
        headers: {
            authorization: ``,
        },
    })
        .then(res => res.data)
};